import { API } from 'aws-amplify';
import { decodeCriteria } from '../shared/constants';

const dayjs = require('dayjs');

export const UPDATE_SESSION_OK = 'UPDATE_SESSION_OK';
export const LOAD_ENVIRONMENT_OK = 'LOAD_ENVIRONMENT_OK';

export function updateSessionAction(values) {
	console.log('UPDATE SESSION: ', values);
	return (dispatch) => {
		dispatch({type: 'set', ...values});
	}
}

export function loadEnvironment(successCb, errorCb) { 
	console.log('LOAD ENVIRONMENT ACTION');
	return async (dispatch) => {
		console.log('LOAD ENVIRONMENT THUNK');
		try {
			let endpoint = '/api/admin/me';

			console.log('Grabbing preferences ... ' + endpoint);
			let prefs = false; // sessionStorage.getItem('prefs');
			if (!prefs) {
				console.log('GRABBING PREFS && COLLECTIONS');
				let prefsResp = await API.get('AncestryVmpApi', endpoint);
				console.log('Found prefs' , { prefsResp });
				delete prefsResp.status;
				sessionStorage.setItem('prefs', JSON.stringify(prefsResp));
				prefs = prefsResp;
			} else {
				prefs = JSON.parse(prefs);
			}
			
			let tags = sessionStorage.getItem('tags');
			if (!tags) {
				console.log('GRABBING TAGS');
				let endpoint2 = '/api/admin/tags';
				const tagsResp = await API.get('AncestryVmpApi', endpoint2);
				console.log('Found tags ' , { tags: tagsResp.tags});
				tags = tagsResp.tags;
				sessionStorage.setItem('tags', JSON.stringify(tags));
			} else {
				tags = JSON.parse(tags);
			}

			console.log('LOAD ENV', {tags, prefs})

			dispatch({type: LOAD_ENVIRONMENT_OK, tags, collections: prefs.collections });
			successCb && successCb();
			return true;
		} catch (error) {
			console.log('LOAD ENV error:', { error });
			errorCb && errorCb(error.message);
			return false;
		}
	}
}